import React, {Component} from 'react';
import IdleTimer from 'react-idle-timer';


export default class TimeOut extends Component{
    constructor(props){
        super(props)
        this.state = {
            itemsDashboard: [],
            counters: [],
            timeout:1000 * 60 * 20,
            showModal: false,
            userLoggedIn: false,
            isTimedOut: false
        };
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
    }
    _onAction(e) {
      //console.log('user did something', e)
      this.setState({isTimedOut: false})
    }
    
    _onActive(e) {
      //console.log('user is active', e)
      this.setState({isTimedOut: false})
    }
    
    _onIdle(e) {
      //console.log('user is idle', e)
      const isTimedOut = this.state.isTimedOut
      if (isTimedOut) {
          this.props.history.push('/')
      } else {
        window.location.reload();
        this.idleTimer.reset();
        this.setState({isTimedOut: true})
      }
      
    }
    render() {
        
        return (
            <IdleTimer
                ref={ref => { this.idleTimer = ref }}
                element={document}
                onActive={this.onActive}
                onIdle={this.onIdle}
                onAction={this.onAction}
                debounce={250}
                timeout={this.state.timeout} 
            />
        )
    }
};